import { reactive } from 'vue'
import type { Quotation, QuotationStatus } from '@/types'

export interface QuotationsState {
  quotations: Quotation[]
  selectedQuotation: Quotation | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    status: QuotationStatus | ''
    organizationId: string
  }
}

export const getInitialState = (): QuotationsState => ({
  quotations: [],
  selectedQuotation: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    status: '',
    organizationId: '',
  },
})

export const createState = (): QuotationsState => {
  return reactive(getInitialState())
}

export const resetState = (state: QuotationsState): void => {
  const initial = getInitialState()
  state.quotations = initial.quotations
  state.selectedQuotation = initial.selectedQuotation
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
